import { listTirages } from '../api/tirages';

// Catalogue des loteries mis en cache en mémoire (chargé une seule fois par
// session) — sert à résoudre un code loterie tapé à la main en son nom, sans
// ouvrir de modal.
let cache = null;
let inflight = null;

export async function getLotteryCatalog() {
  if (cache) return cache;
  if (!inflight) {
    inflight = listTirages()
      .then((list) => { cache = Array.isArray(list) ? list : []; return cache; })
      .finally(() => { inflight = null; });
  }
  return inflight;
}

/**
 * Résout un code loterie -> { code, name } ou null si introuvable.
 * '' -> null ; '0' -> { code:'0', name:'TOUS' }.
 */
export async function resolveLotteryByCode(code) {
  const c = String(code ?? '').trim();
  if (c === '') return null;
  if (c === '0') return { code: '0', name: 'TOUS' };
  const list = await getLotteryCatalog().catch(() => []);
  const found = list.find((t) => String(t.code) === c);
  return found ? { code: String(found.code), name: found.name } : null;
}
